import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

/* Custom cursor: small dot + trailing ring that grows over links/buttons. Desktop only. */
export default function Cursor() {
  const [enabled, setEnabled] = useState(false);
  const [hover, setHover] = useState(false);
  const [down, setDown] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const rx = useSpring(x, { stiffness: 350, damping: 30, mass: 0.6 });
  const ry = useSpring(y, { stiffness: 350, damping: 30, mass: 0.6 });

  useEffect(() => {
    const fine = window.matchMedia('(pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine) return undefined;
    setEnabled(true);
    document.documentElement.classList.add('has-cursor');
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) => setHover(!!e.target.closest('a, button, [role="button"], input, select, textarea, .tilt, .cursor-grow'));
    const d = () => setDown(true); const u = () => setDown(false);
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerover', over);
    window.addEventListener('pointerdown', d);
    window.addEventListener('pointerup', u);
    return () => {
      document.documentElement.classList.remove('has-cursor');
      window.removeEventListener('pointermove', move); window.removeEventListener('pointerover', over);
      window.removeEventListener('pointerdown', d); window.removeEventListener('pointerup', u);
    };
  }, [x, y]);

  if (!enabled) return null;
  return (
    <>
      <motion.div className="cursor-ring" style={{ x: rx, y: ry }} animate={{ scale: down ? 0.8 : hover ? 1.9 : 1, opacity: hover ? 0.9 : 0.55 }} transition={{ type: 'spring', stiffness: 300, damping: 22 }} />
      <motion.div className="cursor-dot" style={{ x, y }} animate={{ scale: hover ? 0 : 1 }} />
    </>
  );
}
